export const lineChartOptions = {
  responsive: true,
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        color: "#1C2B58",
        font: {
          size: 14,
          weight: "bold",
        },
      },
    },
    y: {
      ticks: {
        padding: 15,
        display: false,
      },
      grid: {
        display: true,
      },
    },
  },
  layout: {
    padding: {
      left: 30,
      right: 30,
      top: 30,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    datalabels: {
      // display: 'auto',
      display: true,
      font: {
        size: 12,
        weight: 600,
      },
      align: "end",
      formatter: function (value) {
        return value.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
      },
    },
  },
  showTooltips: false,
  spanGaps: true,
};
export const barChartOptions = {
  responsive: true,
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        color: "#1C2B58",
        font: {
          size: 14,
          weight: "bold",
        },
      },
      stacked: true,
    },
    y: {
      grid: {
        display: true,
      },
      ticks: {
        color: "#1C2B58",
        font: {
          size: 14,
          weight: "bold",
        },
        stepSize: 20,
      },
      // max: 100,
      stacked: true,
    },
  },
  layout: {
    padding: {
      left: 30,
      right: 30,
    },
  },
  plugins: {
    tooltip: {
      callbacks: {
        title: (tooltipItem, index) => {
          return tooltipItem[0].dataset.label;
        },
        label: (tooltipItem) => {
          const index = tooltipItem.dataIndex;
          const date = tooltipItem.dataset.dates[index];
          const volume = tooltipItem.dataset.volumeAtivoPorMes?.[date]?.toFixed(2) ? tooltipItem.dataset.volumeAtivoPorMes?.[date]?.toFixed(2) : tooltipItem.dataset.volumePorMes?.[date]?.toFixed(2)
          return `Tonelada: ${volume}`
        }
      }
    },
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    datalabels: {
      // display: 'auto',
      display: true,
      color: "white",
      font: {
        size: 13,
        weight: 600,
      },
      formatter: function (value) {
        return `${value}${value ? '%' : ''}`;
      },
    },
  },
};
